import { HttpClient } from './types';
import { CryptoHelper, configurationEncoder, type ConfigurationEncode } from '@ecommerce/shared-utils';

export const createAuthService = (httpClient: HttpClient) => {
    const getEndpoint = (url: string = ""): string => `/auth${url}`;

    return {
        authenticateUser: async <TAuthResponse = any>(
            mail: string,
            password: string,
            config?: any
        ): Promise<TAuthResponse> => {
            const encoder: ConfigurationEncode = await configurationEncoder.getConfiguration();
            const passwordEncrypted = CryptoHelper.encrypt(encoder, password);

            return httpClient.post<TAuthResponse>(
                getEndpoint("/login"),
                {
                    Mail: mail,
                    Password: passwordEncrypted,
                    IpClient: ""
                },
                {
                    ...config,
                    headers: {
                        ...config?.headers,
                        Authorization: undefined
                    }
                }
            );
        },

        registerUser: async <TAuthResponse = any>(
            nombre: string,
            apellido: string,
            codigoArea: string,
            telefono: string,
            mail: string,
            password: string,
            fechaNacimiento: string,
            config?: any
        ): Promise<TAuthResponse> => {
            const encoder: ConfigurationEncode = await configurationEncoder.getConfiguration();
            const passwordEncrypted = CryptoHelper.encrypt(encoder, password);

            return httpClient.post<TAuthResponse>(
                getEndpoint("/register"),
                {
                    Nombre: nombre,
                    Apellido: apellido,
                    CodigoArea: codigoArea,
                    Telefono: telefono,
                    Mail: mail,
                    Password: passwordEncrypted,
                    IpClient: "",
                    FechaNacimiento: fechaNacimiento
                },
                {
                    ...config,
                    headers: {
                        ...config?.headers,
                        Authorization: undefined
                    }
                }
            );
        },

        enviarCodigoRecuperoContrasenia: <TRecuperoContraseniaResponse = any>(
            mail: string,
            config?: any
        ): Promise<TRecuperoContraseniaResponse> => {
            return httpClient.post<TRecuperoContraseniaResponse>(
                getEndpoint("/recupero-contrasenia/enviar-codigo"),
                {
                    Mail: mail
                },
                {
                    ...config,
                    headers: {
                        ...config?.headers,
                        Authorization: undefined
                    }
                }
            );
        },

        verificarCodigoRecuperoContrasenia: <TRecuperoContraseniaResponse = any>(
            mail: string,
            codigo: string,
            config?: any
        ): Promise<TRecuperoContraseniaResponse> => {
            return httpClient.post<TRecuperoContraseniaResponse>(
                getEndpoint("/recupero-contrasenia/verificar-codigo"),
                {
                    Mail: mail,
                    Codigo: codigo
                },
                {
                    ...config,
                    headers: {
                        ...config?.headers,
                        Authorization: undefined
                    }
                }
            );
        },

        restablecerContrasenia: async <TRecuperoContraseniaResponse = any>(
            mail: string,
            codigo: string,
            passwordNueva: string,
            config?: any
        ): Promise<TRecuperoContraseniaResponse> => {
            const encoder: ConfigurationEncode = await configurationEncoder.getConfiguration();
            const passwordEncrypted = CryptoHelper.encrypt(encoder, passwordNueva);

            return httpClient.post<TRecuperoContraseniaResponse>(
                getEndpoint("/recupero-contrasenia/restablecer"),
                {
                    Mail: mail,
                    Codigo: codigo,
                    PasswordNueva: passwordEncrypted
                },
                {
                    ...config,
                    headers: {
                        ...config?.headers,
                        Authorization: undefined
                    }
                }
            );
        },

        getUser: <TUser = any>(): Promise<TUser> => {
            return httpClient.get<TUser>(getEndpoint(""));
        },

        updateProfile: <TUser = any>(data: {
            nombre?: string;
            apellido?: string;
            codigoArea?: string;
            telefono?: string;
            fechaNacimiento?: string | null;
        }): Promise<TUser> => {
            return httpClient.put<TUser>(
                getEndpoint(""),
                {
                    nombre: data.nombre ?? null,
                    apellido: data.apellido ?? null,
                    codigoArea: data.codigoArea ?? null,
                    telefono: data.telefono ?? null,
                    fechaNacimiento: data.fechaNacimiento ?? null
                }
            );
        },

        refreshTokens: <TTokenResponse = any>(): Promise<TTokenResponse> => {
            return httpClient.post<TTokenResponse>(getEndpoint("/refresh-tokens"), {});
        },
    };
};